import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './sa_group_create.routes';
import SaGroupService from '../../../components/api/sa_group/sa_group.service';
import SaConfigService from '../../../components/api/sa_config/sa_config.service';

export class SaGroupCreateController {
  /*@ngInject*/
  constructor($state, $mdDialog, SaGroupService, SaConfigService) {
    this.SaGroupService = SaGroupService;
    this.SaConfigService = SaConfigService;
    this.$state = $state;
    this.$mdDialog = $mdDialog;

    this.configIds = [];
    this.allIds = [];

    this.submitted = false;

    this.dialog = {
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: '作成が完了しました',
        content: '一覧 画面に移動します',
        ok: 'OK'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'エラーが発生しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      })
    };
  }

  $onInit() {
    this.SaConfigService.api.index(response => {
      this.configList = response;
    });
  }

  createGroup(groupConfig, $event) {
    this.submitted = true;

    this.SaGroupService.api.create(
      angular.merge(groupConfig, { config_ids: this.configIds }),
      ok => {
        this.$mdDialog.show(this.dialog.success)
          .finally(() => { this.$state.go('main.sa_group_index'); });
      },
      ng => {
        this.submitted = false;
        this.$mdDialog.show(this.dialog.error);
      }
    )
  }
}

export default angular.module('leptonApp.saGroupCreate', [uiRouter, SaGroupService, SaConfigService])
  .config(routing)
  .component('saGroupCreate', {
    template: require('./sa_group_create.html'),
    controller: SaGroupCreateController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/sa_group/create/sa_group_create.component.js